import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import {
  Portal, Box, useDisclosure, IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Flex,
  Text,
  VStack,
  ScaleFade,
} from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import {
  MdHome,
  MdBusiness,
  MdPerson,
  MdContacts,
  MdEditCalendar,
  MdEvent,
  MdWorkHistory,
  MdAssuredWorkload,
  MdOutlineLan,
  MdNoteAlt,
} from 'react-icons/md';
import MainDashboard from 'views/admin/dashboard/components/Dashboard';
import Attendance from 'views/admin/attendance';
import LeavesList from 'views/admin/leaveManagement/components/LeavesList';
import EmployeeProfile from 'views/admin/employeeProfile/EmployeeProfile';
import CompanyProfile from 'views/admin/companyProfile/components/CompanyProfile';
import Directory from 'views/admin/directory/components/Directory';
import Workweek from 'views/admin/workweek/components/Workweek';
import Payroll from 'views/admin/payrollAnalytics/components/PayrollAnalytics';
import { authProtectedRoutes } from 'routes';
import Cookies from 'js-cookie';
import Operations from 'views/admin/operations';
import ChatBot from 'components/chatbot/ChatBot';
import Announcements from 'views/admin/Announcement/components/Announcements';
import ProfileAudit from 'views/admin/auditLogs/components/ProfileAudit';
// import CompanyAudit from 'views/admin/auditLogs/components/CompanyAudit';
import { IoNotifications } from 'react-icons/io5';
import { AiOutlineAudit } from 'react-icons/ai';
import WFHPage from 'views/admin/WFH/components/WFHPage';
import { MdAddHomeWork } from 'react-icons/md';
import { QuestionOutlineIcon, CloseIcon, } from "@chakra-ui/icons";
import {
  MessageCircle,
  PlayCircle,
  Compass,
} from "lucide-react";
import TourProvider from 'components/ProductTour/TourProvider'
import StartTourButton from 'components/ProductTour/StartTourButton';

const componentsMap = {
  MainDashboard,
  Attendance,
  LeavesList,
  EmployeeProfile,
  CompanyProfile,
  Directory,
  Workweek,
  Payroll,
  Operations,
  Announcements,
  ProfileAudit,
  WFHPage,
};

const iconsMap = {
  MdHome,
  MdBusiness,
  MdContacts,
  MdEditCalendar,
  MdEvent,
  MdWorkHistory,
  MdPerson,
  MdAssuredWorkload,
  MdOutlineLan,
  IoNotifications,
  AiOutlineAudit,
  MdAddHomeWork,
};

export default function Dashboard(props) {
  // const authUser = Cookies.get('authUser');
  const authUser = localStorage.getItem('authUser'); // Check for authUser
  // Check for authUser
  let parsedData = [];
  try {
    const processedData = localStorage.getItem('accessModules');
    // Only parse if non-empty, valid JSON
    if (processedData && processedData.trim() !== '') {
      parsedData = JSON.parse(processedData);
    }
  } catch (err) {
    console.error('Error parsing accessModules:', err);
    parsedData = [];
  }

  const routes = parsedData.map((item) => {
    return {
      ...item,
      icon: React.createElement(iconsMap[item.icon], {
        width: '20px',
        height: '20px',
        color: 'inherit',
      }),
      component: componentsMap[item.component],
    };
  });

  const { ...rest } = props;
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { onOpen } = useDisclosure();

  const [showOptions, setShowOptions] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);
  const [showTour, setShowTour] = useState(false);

  const navigate = useNavigate();

  // Redirect to login if authUser is not found
  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  if (!sessionStorage.getItem('Logged In')) {
    localStorage.removeItem('authUser');
    return <Navigate to="/login" replace />;
  }

  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };

  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/admin') {
        return (
          <Route
            path={`${route.path}`}
            element={<route.component />}
            key={key}
          />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };

  const getAuthProtectedRoutes = (routes) => {
    return routes.map((route, key) => {
      return (
        <Route path={`${route.path}`} element={<route.component />} key={key} />
      );
    });
  };


  const startTourAgain = () => {
    sessionStorage.setItem("show-tour-welcome", "true");
    sessionStorage.removeItem("sam-auto-tour");
    navigate("/admin/default");
  };

  document.documentElement.dir = 'ltr';

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar
            isCollapsed={isCollapsed}
            routes={routes}
            display="none"
            {...rest}
          />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{
              base: '100%',
              xl: isCollapsed ? 'calc( 100% - 60px )' : 'calc( 100% - 230px )',
            }}
            maxWidth={{
              base: '100%',
              xl: isCollapsed ? 'calc( 100% - 60px )' : 'calc( 100% - 230px )',
            }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  setIsCollapsed={setIsCollapsed}
                  isCollapsed={isCollapsed}
                  onOpen={onOpen}
                  logoText={'SΛM LĪTΞ'}
                  brandText={getActiveRoute(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <TourProvider routes={routes} />
                <Routes>
                  {getRoutes(routes)}
                  {getAuthProtectedRoutes(authProtectedRoutes)}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
                <Box
                  position="fixed"
                  bottom="30px"
                  right="0"
                  //transform="translateX(5px)"
                  zIndex={9999}
                >
                  <ScaleFade initialScale={0.9} in={showOptions} style={{
                    pointerEvents: showOptions ? "auto" : "none",
                  }}>
                    <VStack spacing={3}
                      position="absolute"
                      bottom="70px"
                      right="0"
                      align="stretch"
                      w="220px">
                      <Flex
                        bg="white"
                        p={4}
                        borderRadius="20px"
                        boxShadow="0 10px 30px rgba(0,0,0,0.15)"
                        cursor="pointer"
                        align="center"
                        gap={3}
                        transition="all .2s"
                        _hover={{
                          transform: "translateY(-2px)",
                          boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
                        }}
                        onClick={() => {
                          setShowChatbot(true);
                          setShowOptions(false);
                        }}
                      >
                        <MessageCircle size={22} color="#805AD5" />
                        <Text fontWeight="600">Chat with us</Text>
                      </Flex>

                      <Flex
                        bg="white"
                        p={4}
                        borderRadius="20px"
                        boxShadow="0 10px 30px rgba(0,0,0,0.15)"
                        cursor="pointer"
                        align="center"
                        gap={3}
                        onClick={() => {
                          startTourAgain();
                          setShowOptions(false);
                        }}
                      >
                        <Compass size={22} color="#38A169" />
                        <Text fontWeight="600">Take a Tour</Text>
                      </Flex>


                      <Flex
                        bg="white"
                        p={4}
                        borderRadius="20px"
                        boxShadow="0 10px 30px rgba(0,0,0,0.15)"
                        cursor="pointer"
                        align="center"
                        gap={3}
                      >
                        <PlayCircle size={22} color="#3182CE" />
                        <Text fontWeight="600">Watch Video</Text>
                      </Flex>
                    </VStack>
                  </ScaleFade>

                  <IconButton
                    size="lg"
                    borderRadius="full"
                    colorScheme="purple"
                    icon={showOptions ? <CloseIcon /> : <QuestionOutlineIcon />}
                    onClick={() => setShowOptions(!showOptions)}
                    boxShadow="xl"
                    aria-label="Need Help"
                  />
                </Box>
                {showChatbot && (
                  <Box
                    position="fixed"
                    bottom="30px"
                    right="10px"
                    zIndex={10000}
                  >
                    <ChatBot
                      defaultOpen={true}
                      onClose={() => setShowChatbot(false)}
                    />
                  </Box>
                )}

                {showTour && (
                  <Box
                    position="fixed"
                    bottom="30px"
                    right="10px"
                    zIndex={10000}
                  >
                    <StartTourButton
                      defaultOpen={true}
                      onClose={() => setShowTour(false)}
                    />
                  </Box>
                )}
              </Box>
            ) : null}
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
